
<template>
  <v-container class="pa-0">
    <info-button class="top-20 pa-0 ma-0 right-0 position-fixed" :header="wishInfoTitle">
      <div>
        <div v-if="wishInfoTopText" v-html="wishInfoTopText" class="mb-2"></div>
        <v-list class="pa-0 ma-0" v-if="settings.shiftsEnabled">
          <v-list-item
              class="ma-0 pa-0"
              :key="shift.nr"
              v-for="shift in settings.shifts"
              v-show="Number(shift.max) <= 56"
          >
          <v-row class="pa-0 ma-0">
            <v-col cols="12">
              <small class="pa-0 ma-0">» max. {{shift.max}} {{ shift.name }}</small>
            </v-col>
            </v-row>
          </v-list-item>
        </v-list>

        <v-list class="pa-0 ma-0" v-if="settings.freeDaysEnabled">
          <v-list-item
              class="ma-0 pa-0"
              :key="shift.nr"
              v-for="shift in settings.freeDays"
              v-show="Number(shift.max) <= 56"
          >
            <v-row class="pa-0 ma-0">
              <v-col cols="12">
                <small class="pa-0 ma-0">» max. {{shift.max}} {{ shift.name }} frei</small>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-list class="pa-0 ma-0" v-if="settings.miscEnabled">
          <v-list-item
              class="ma-0 pa-0"
              :key="shift.nr"
              v-for="shift in settings.misc"
              v-show="Number(shift.max) <= 56"
          >
            <v-row class="pa-0 ma-0">
              <v-col cols="12">
                <small class="pa-0 ma-0">» max. {{shift.max}} {{ shift.name }} </small>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-row class="pa-0 ma-0 mt-2" v-if="settings.schematasEnabled">
          <v-col cols="12" class="mt-4">
          <v-row>
              <span class="pa-0 ma-0"><b>{{ wishSchemaTitle }}</b></span>
          </v-row>
            <v-row>
              <span class="pa-0 ma-0 mb-2">{{ wishSchemaSubtitle }}</span>
            </v-row>

            <v-list class="pa-0 ma-0">
              <v-list-item
                  class="ma-0 pa-0"
                  :key="shift.nr"
                  v-for="shift in settings.schematas"
              >
                <v-row class="pa-0 ma-0">
                  <v-col cols="12">
                    <small class="pa-0 ma-0">» {{  JSON.stringify(shift.schemata) }} Tage</small>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <v-row class="pa-0 ma-0 mt-2">
          <v-col cols="12" class="mt-4">
            <div v-html="dutyRulesText"></div>
          </v-col>
        </v-row>
      </div>
    </info-button>
    <v-progress-linear v-if="isLoading" indeterminate color="primary"></v-progress-linear>
    <div class="dateBox mb-4">
      <p class="year">{{wishPeriod?.title}}</p>
      <p class="year">{{wishPeriod?.startDate.getFullYear()}}</p>
      <p class="date">{{ dateTimeString }}</p>
    </div>

    <div class="d-flex flex-column justify-center justify-space-between mb-2 mt-4" v-if="overview">
      <v-row class="flex-row">
        <span class="flex-1-0-0 text-center">{{shiftStrings.frueh}}</span>
        <span class="flex-1-0-0 text-center">{{shiftStrings.mittel}}</span>
        <span class="flex-1-0-0 text-center">{{shiftStrings.spaet}}</span>
      </v-row>
      <v-row class="flex-row">
        <span class="flex-1-0-0 text-center">{{shiftStrings.ne}}</span>
<!--        <span class="flex-1-0-0 text-center">{{shiftStrings.geteilt}}</span>-->
        <span class="flex-1-0-0 text-center">{{shiftStrings.frei}}</span>
      </v-row>
    </div>
    
    <div v-if="!overview">
      <ShiftSelector @schicht-selected="(value) => {selectedShift = value}"></ShiftSelector>
    </div >

    <div class="my-4 d-flex flex-column justify-center justify-space-between" v-if="!overview">
      <v-row class="flex-row">
        <span class="flex-1-0-0 text-center">{{shiftLeftStrings.frueh}}</span>
        <span class="flex-1-0-0 text-center">{{shiftLeftStrings.mittel}}</span>
      </v-row>
      <v-row class="flex-row">
        <span class="flex-1-0-0 text-center">{{shiftLeftStrings.spaet}}</span>
        <v-tooltip :disabled="vacationFreeDays === 0" open-on-click="true" contained location="bottom">
          <template v-slot:activator="{ props }">
            <span
                class="flex-1-0-0 text-center"
                v-bind="props"
            >
            {{ shiftLeftStrings.frei }} 
            <small v-if="vacationFreeDays > 0" class="text-center">({{ vacationFreeDays }} Tage verplant)</small>
            </span>
          </template>
          <span v-html="freeDayTooltip"></span>
        </v-tooltip>
      </v-row>
    </div>

    <div class="calendarBox mb-2">
      <v-calendar ref="calendar"
                  v-if="minDate && wishPeriod?.endDate"
                  :expanded="expanded"
                  borderless
                  @dayclick="dayClick"
                  :columns="columns"
                  :min-date=minDate
                  :max-date=wishPeriod?.endDate
                  :show-overflow="true"
                  :attributes="attributes"/>
    </div>

    <v-container v-if="overview" class="mb-8">
      <v-row class="d-flex flex-row align-content-center justify-space-around">
        <text-with-dot class="flex-1-0-0 text-center" label-text="Früh" color="orange"></text-with-dot>
        <text-with-dot class="flex-1-0-0 text-center" label-text="Mittel" color="pink"></text-with-dot>
        <text-with-dot class="flex-1-0-0 text-center" label-text="Spät" color="purple"></text-with-dot>
      </v-row>
      <v-row class="d-flex flex-row align-content-center">
        <text-with-dot class="flex-1-0-0 text-center" label-text="NE" color="blue"></text-with-dot>
<!--        <text-with-dot class="flex-1-0-0 text-center" label-text="Geteilt" color="teal"></text-with-dot>-->
        <text-with-dot class="flex-1-0-0 text-center" label-text="Frei" color="green"></text-with-dot>
      </v-row>
    </v-container>

    <div>
      <error-list class="px-4 mb-2 position-relative" :errors="localRulebreaks"></error-list>
    </div>
    
    <v-container class="mt-auto" style="position: sticky; bottom: 0;" fluid>
      <v-textarea :disabled="wishPeriod?.locked" class="mb-4" v-model="localDescription" label="Bemerkung"></v-textarea>
      
      <div v-if="!overview" class="mb-2 d-flex justify-space-between flex-end">
        <v-btn  class="ma-0 flex-1-0-0 mr-3" color="secondary" @click="goBack">Verwerfen</v-btn>
        <v-menu bottom>
          <template v-slot:activator="{ props }">
            <v-btn class="ma-0 flex-1-0-0 ml-3"
                   color="secondary"
                   v-bind="props" >
              Vorlagen
            </v-btn>
          </template>
          <v-list>
            <v-list-item
                v-for="(item, index) in templates"
                :key="index"
                :value="index"
                @click="applyTemplate(item)"
            >
              <v-list-item-title>{{ item.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div v-if="!overview && canSave" class="mb-1 d-flex justify-space-between flex-end">
        <v-btn :disabled="isSaving" class="ma-0 flex-1-0-0" color="primary" @click="wishessave" >Speichern</v-btn>
      </div>
      <div v-else class="mb-4">
        <small>Hinweis: Erst ab 56 verplanten Tagen kann gespeichert werden. Bisher verplant {{shiftStrings.gesamt}}</small>
      </div>

      <div  v-if="overview && !wishPeriod.locked" class="mb-1 d-flex pa-0 justify-space-between flex-end">
        <v-btn :disabled="isSaving" class="ma-0 flex-1-0-0 mr-3" color="secondary" @click="overview = !overview">Zurück</v-btn>
        <v-btn :disabled="isSaving" class="ma-0 flex-1-0-0 ml-3" color="primary" @click="goToOverview">Speichern</v-btn>
      </div>

      <div  v-if="overview && wishPeriod.locked" class="mb-1 d-flex pa-0 justify-space-between flex-end">
        <v-btn :disabled="isSaving" class="ma-0 flex-1-0-0 " color="secondary" @click="goBack">Zurück</v-btn>
      </div>
      
    </v-container>
  </v-container>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, ref, watch} from 'vue';
import TextWithDot from "@/components/TextWithDot.vue";
import {onBeforeRouteLeave, useRoute} from 'vue-router';
import {useScreens} from 'vue-screen-utils';
import {useStore} from "@/store";
import {v4 as uuidv4} from 'uuid';
import router from "@/router";
import {createDialog, notifySuccess, notifyWarning} from "vuetify3-dialog";
import {calculateReducedFreeDays, checkRuleBreaksForShifts, getInfoText, loadRuleConfig, RuleBreakData} from "@/rules/ruleEngine";
import ShiftSelector from "@/components/ShiftSelector.vue";
import {GetWishData, InsertWishData, InsertWishDataDates} from "@/data/wishData";
import { GetEmployServiceDataDate } from '@/data/employData';
import {GetWishPeriod} from "@/data/wishPeriod";
import {GetRuleConfig} from "@/data/ruleConfig";
import { normalizeDate, formatDateRangeDE, isSameDate, toAppTimezone, formatDateDE } from '@/utils/dateUtils';
import {useCollection} from "vuefire";
import {addDoc, collection, query, where} from "firebase/firestore";
import {db} from "@/main";
import {GetTemplateData} from "@/data/templateData";
import infoButton from "@/components/InfoButton.vue";
import ErrorList from "@/components/ErrorList.vue";
import { convertUtcToGermanLocal, getNormalizedService } from "@/hooks/utils"

export default defineComponent({
  components: {ShiftSelector, TextWithDot, infoButton, ErrorList},
  setup() {
    const store = useStore();
    const route = useRoute();
    const settings = ref(store.state.userData.userSettings);
    const dutyRulesText = ref(getInfoText("dutyRules"));
    const wishInfoTitle = ref(getInfoText("wishInfoTitle"));
    const wishInfoTopText = ref(getInfoText("wishInfoTop"));
    const wishSchemaTitle = ref(getInfoText("wishSchemaTitle"));
    const wishSchemaSubtitle = ref(getInfoText("wishSchemaSubtitle"));
    const employ = ref(store.state.userData.employData);
    
    const maxFruehdiensteInEightWeeks = settings.value?.shifts?.filter((shift: any) => parseInt(shift.nr, 10) === 1)?.[0]?.max ?? 0
    const maxSpaetdiensteInEightWeeks = settings.value?.shifts?.filter((shift: any) => parseInt(shift.nr, 10) === 3)[0].max ?? 0
    const maxMitteldiensteInEightWeeks = settings.value?.shifts?.filter((shift: any) => parseInt(shift.nr, 10) === 2)[0].max ?? 0
    const maxFreeDaysInEightWeeks = settings.value?.shifts?.filter((shift: any) => parseInt(shift.nr, 10) === 10)[0].max ?? 0
    const vacationFreeDays = ref(0);
    const first14Days = ref<WishDataDate[]>([])
    
    const nightexpress = ref(store.state.calendarData.newCalendarData.nightexpressData);
    const holidays = ref(store.state.calendarData.newCalendarData.holidaysData);
    const vacation = ref(store.state.userData.employVacationData);
    const calendar = ref(null);
    const selectedShift = ref('');
    const wishPeriod = ref<WishPeriod | null | undefined>(null);
    const userId = store.getters.userId;
    const userData = store.state.userData.user;
    const inputDates = ref<WishDataDate[]>([]);
    const localWishData = ref<WishData | null | undefined>(null);
    const localEmployServiceData = ref<EmployServiceData[] | null | undefined>(null);
    const overview = ref(false);
    const edited = ref(false);
    const localDescription = ref<string | undefined>('');
    const localRulebreaks = ref<RuleBreakData[]>([]);
    const isSaving = ref(false);
    const canSave = computed(() => {
      return inputDates.value?.length >= 56;
    })
    
    const attributes = computed(() => {
      // v-calendar wirft "dayIndex"-Fehler bei ungueltigen Daten -> nur echte, gueltige Dates zulassen
      const isValidDate = (d: unknown): d is Date => d instanceof Date && !isNaN(d.getTime());
      // Store enthaelt Feiertage/Nachtexpress mehrerer Jahre -> auf Kalender-Bereich (startDate-14 .. endDate) begrenzen
      const min = wishPeriod.value?.startDate
        ? (() => { const d = new Date(wishPeriod.value.startDate); d.setDate(d.getDate() - 14); return d; })()
        : null;
      const max = wishPeriod.value?.endDate ?? null;
      const inRange = (d: Date): boolean =>
        (!(min instanceof Date) || d.getTime() >= min.getTime()) &&
        (!(max instanceof Date) || d.getTime() <= max.getTime());
      const validInRange = (d: unknown): d is Date => isValidDate(d) && inRange(d);
      const baseAttributes = [
        {
          key: '1', // Früh
          highlight: {
            color: 'orange', // Orange
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '2', // Mittel
          highlight: {
            color: 'pink',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '3', // Spät
          highlight: {
            color: 'purple',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '5', // Geteilt
          highlight: {
            color: 'teal',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '4', // NE
          highlight: {
            color: 'blue',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: '10', // Frei
          highlight: {
            color: 'green',
            fillMode: 'solid',
            contentClass: 'italic',
          },
          dates: [],
        },
        {
          key: 'nightexpress', // Nachtexpress
          bar: 'darkblue',
          popover: {
            label: 'Nachtexpress',
            visibility: 'hover',
          },
          dates: [],
        },
      ];
      
      const dynamicAttributesHolidays = [...new Set(holidays.value.map(dateObject => dateObject.Name))].map(name => ({
        bar: 'green',
        popover: {
          label: name,
          visibility: 'hover',
        },
        dates: holidays.value
            .filter(dateObject => dateObject.Name === name && validInRange(dateObject.Date))
            .map(dateObject => dateObject.Date),
      }));

      const dynamicAttributesVacation = {
        highlight: {
          color: 'green',
          fillMode: 'outline',
        },
        popover: {
          label: "Urlaub",
          visibility: 'hover',
        },
        dates: vacation.value.map(dateObject => dateObject.date),
      };
      
      const dynamicAttributesRules = [...new Set(localRulebreaks.value.filter(dateObject => validInRange(dateObject.Date)).map(dateObject => dateObject.ruleShortMessage))].map(name => ({
        key: name, // Using name as the key
        bar: 'red',
        popover: {
          label: name,
          visibility: 'hover',
        },
        dates: localRulebreaks.value
            .filter(dateObject => dateObject.ruleShortMessage === name && validInRange(dateObject.Date))
            .map(dateObject => dateObject.Date),
      }));
      
      // Merge static baseAttributes with dynamically created attributes
      const baseAttributeContent =  baseAttributes.map(attribute => {
        let datesForAttribute;
        if (attribute.key === 'nightexpress') {
          datesForAttribute = nightexpress.value
              .filter(dateObject => dateObject.nightexpress === 1 && validInRange(dateObject.Date))
              .map(dateObject => dateObject.Date);
        } else if (attribute.key !== 'nightexpress') {
          datesForAttribute = inputDates.value
              .filter(dateObject => dateObject.shift.toString() === attribute.key)
              .map(dateObject => dateObject.date);
        }

        return {
          ...attribute,
          dates: datesForAttribute,
        };
      });

      const generateMondayAttributes = () => {
        if(wishPeriod.value === null || wishPeriod.value === undefined)
          return [];
        
        const mondays = [];
        let current = new Date(wishPeriod.value.startDate);

        // Find the first Monday of the month
        while (current.getDay() !== 1) {
          current.setDate(current.getDate() + 1);
        }

        // Collect all Mondays in the range
        while (current <= wishPeriod.value.endDate) {
          mondays.push(new Date(current));
          current.setDate(current.getDate() + 7);
        }

        // Assign colors in two-week blocks
        return mondays.map((monday, index) => ({
          dates: monday,
          dot: Math.floor(index / 2) % 2 === 0 ? 'red' : 'blue',
        }));
      };

      const first14DaysAttributes = computed(() => {
        const shiftColors = {
          1: { color: 'orange', name: 'Früh' },    // Früh
          2: { color: 'pink', name: 'Mittel' },    // Mittel  
          3: { color: 'purple', name: 'Spät' },    // Spät
          4: { color: 'blue', name: 'NE' },        // Nachtexpress
          10: { color: 'green', name: 'Frei' },    // Frei
          99: { color: 'yellow', name: '* Dienst' },// * Dienst (Punktdienst)
        };
        
        return Object.entries(shiftColors).map(([shiftNumber, config]) => ({
          key: `previous-${shiftNumber}`,
          highlight: {
            color: config.color,
            fillMode: 'light',  // 'outline' für gestrichelte Umrandung
            contentClass: 'italic',
          },
          popover: {
            label: `${config.name} (vorherige 14 Tage)`,
            visibility: 'hover',
          },
          dates: first14Days.value
              .filter(dateObject => dateObject.shift === parseInt(shiftNumber))
              .map(dateObject => dateObject.date),
        }));
      });
      
      // Merge static baseAttributes with dynamically created attributes
      return  [...dynamicAttributesHolidays, dynamicAttributesVacation, ...dynamicAttributesRules, 
        ...baseAttributeContent, ...generateMondayAttributes(), ...first14DaysAttributes.value]
        // Attribute mit leerem dates-Array entfernen (Einzeldatum-Attribute bleiben) -> verhindert "dayIndex"-Fehler
        .filter((attr: any) => !Array.isArray(attr.dates) || attr.dates.length > 0);
    });

    const templates = useCollection(query(
        collection(db, "templates"),
        where("userId", "==", userId),
    ));
    
    const { mapCurrent } = useScreens({
      xs: '0px',
      sm: '640px',
      md: '768px',
      lg: '1024px',
    });
    const columns = mapCurrent({ lg: 2 }, 1);
    const expanded = mapCurrent({ sm: false, lg: true }, true);
    
    const isLoading = computed(() => {
      return wishPeriod.value === null || wishPeriod.value === undefined;
    });
    
    const shiftStrings = computed(() => {
      const shiftCounts = {
        frueh: inputDates.value.filter(d => d.shift === 1).length,
        mittel: inputDates.value.filter(d => d.shift === 2).length,
        spaet: inputDates.value.filter(d => d.shift === 3).length,
        geteilt: inputDates.value.filter(d => d.shift === 5).length,
        ne: inputDates.value.filter(d => d.shift === 4).length,
        frei: inputDates.value.filter(d => d.shift === 10).length,
        gesamt : inputDates.value.length,
      };

      return {
        frueh: `${shiftCounts.frueh}xFrüh`,
        mittel: `${shiftCounts.mittel}xMittel`,
        spaet: `${shiftCounts.spaet}xSpät`,
        geteilt: `${shiftCounts.geteilt}xGeteilt`,
        ne: `${shiftCounts.ne}xNE`,
        frei: `${shiftCounts.frei}xFrei`,
        gesamt: `${shiftCounts.gesamt}xGesamt`,
      };
    });

    const shiftLeftStrings = computed(() => {
      const shiftCounts = {
        frueh: maxFruehdiensteInEightWeeks - inputDates.value.filter(d => d.shift === 1).length,
        mittel: maxMitteldiensteInEightWeeks -inputDates.value.filter(d => d.shift === 2).length,
        spaet: maxSpaetdiensteInEightWeeks -inputDates.value.filter(d => d.shift === 3).length,
        frei: maxFreeDaysInEightWeeks - vacationFreeDays.value - inputDates.value.filter(d => d.shift === 10).length,
      };

      return {
        frueh: `${shiftCounts.frueh}xFrüh`,
        mittel: `${shiftCounts.mittel}xMittel`,
        spaet: `${shiftCounts.spaet}xSpät`,
        frei: `${shiftCounts.frei}xFrei`,
      };
    });
    
    const freeDayTooltip = computed(() => {
      let reduction = 0;
      
      if(employ.value?.cycleid === '170t')
        reduction = 4;
      if(employ.value?.cycleid === '170u')
        reduction = 3;
      else
        reduction = 2;
      
      if(employ.value?.cycleid === '170v')
      {
        return "In der ersten Woche Urlaub werden 3 freie Tage verplant. <br>" +
               "In der zweiten Woche Urlaub werden 4 freie Tage verplant."
      }
      else{
        return `Für jede volle Woche Urlaub werden ${reduction} freie Tage verplant. <br>` +
                "Ab 1 Wochen Urlaub wird zusätzlich automatisch ein Samstag als freier Tag verplant."
      }
      
    });
    
    const dateTimeString = computed(() => {
      if(wishPeriod.value === null || wishPeriod.value === undefined)
        return '';
      
      return formatDateRangeDE(wishPeriod.value.startDate, wishPeriod.value.endDate);
    });

    const normalizeDateLocal = (date: Date | string): Date => {
      return normalizeDate(date);
    };
    
    watch(inputDates.value, (newVal) => {
      const ruleBreaks = checkRuleBreaksForShifts(newVal, vacationFreeDays.value, first14Days.value);
      if (ruleBreaks.length === 0) {
        isSaving.value = false;
      } else {
        isSaving.value = true;
      }
      localRulebreaks.value.splice(0, localRulebreaks.value.length);
      localRulebreaks.value.push(...ruleBreaks);
    });

    const hostname = window.location.hostname;

    onMounted(async () => {
      try {
        const cfg = await GetRuleConfig();
        loadRuleConfig(cfg);
        dutyRulesText.value = getInfoText("dutyRules");
        wishInfoTitle.value = getInfoText("wishInfoTitle");
        wishInfoTopText.value = getInfoText("wishInfoTop");
        wishSchemaTitle.value = getInfoText("wishSchemaTitle");
        wishSchemaSubtitle.value = getInfoText("wishSchemaSubtitle");
      } catch (error) {
        console.error("Error loading info text:", error);
      }
      var wishPeriodId = route.params.id;
      console.log("PAGE", hostname)
      if(wishPeriodId === undefined)
        return;

      try {
        wishPeriod.value = await GetWishPeriod(wishPeriodId);

        if(wishPeriod.value?.locked){
          overview.value = true;
        }

        if (calendar.value) {
         await calendar.value.focusDate(wishPeriod.value.startDate);
        }
        const startDay = new Date(wishPeriod.value.startDate)
        const endDay = new Date(wishPeriod.value.startDate)
        startDay.setDate(startDay.getDate() - 14)
        endDay.setDate(endDay.getDate() - 1)
        localEmployServiceData.value = await GetEmployServiceDataDate(employ.value?.emplno, convertUtcToGermanLocal(startDay), convertUtcToGermanLocal(endDay))
        console.log("EmployServiceData", localEmployServiceData.value)
        for (const lesd of localEmployServiceData.value) {
          const normalizedService = parseInt(getNormalizedService(lesd), 10)
          let wD: WishDataDate = {} as WishDataDate
          wD.id = lesd.id
          wD.date = new Date(lesd.date)
          wD.employNr = lesd.emplno
          wD.shift = isNaN(normalizedService) ? 99 : normalizedService
          wD.wishPeriodId = wishPeriod.value.id
          first14Days.value.push(wD)
        }

        localWishData.value = await GetWishData(wishPeriodId, employ.value?.emplno); //userId
        
        localDescription.value = localWishData.value?.bemerkung;
        
        for(const date of localWishData.value?.dates ?? []){
          inputDates.value.push(date);
        }
      }
      catch(e){
        console.info(e, "Keine bestehenden Daten für diesen Zeitraum gefunden");
      }
      
      
      try{
        if (vacation.value && wishPeriod.value) {
          
          const trimmedVacation = vacation.value.filter(d => {
            const date = new Date(d.date);
            return date >= wishPeriod.value.startDate && date <= wishPeriod.value.endDate;
          });
          
          vacationFreeDays.value = calculateReducedFreeDays(trimmedVacation, employ.value?.cycleid);
/*          const inputDatesTrimmed = inputDates.value.filter(
              (map) => !trimmedVacation.some(
                  (vacation) => normalizeDate(map.date).getTime() === normalizeDate(vacation.date).getTime()
              )
          );*/
          let _anz = 1
          for (const _vacation of trimmedVacation) {
            let vD: WishDataDate = {} as WishDataDate
            const dayOfWeek = _vacation.date.getDay();
//            const tage = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
            const _str = _vacation.date_str
            vD.id = _str.replaceAll("-", "")
            vD.date = _vacation.date
            vD.employNr = _vacation.emplno
            vD.vacation = true
            vD.shift = 11
            vD.wishPeriodId = wishPeriod.value.id
/*            if (trimmedVacation.length % 7 === 0 && dayOfWeek === 1) {
//              const wochentag = tage[new Date(_vacation.date_str).getDay()];
              switch (_anz) {
                case 6:
                case 7:
                case 13:
                case 14:
                case 20:
                case 21:
                case 27:
                case 28:
                case 34:
                case 35:
                case 41:
                case 42:
                  //vD.shift = 12
                  break
              } 
            } else if (dayOfWeek === 0 || dayOfWeek === 6) {
              vD.shift = 12
            } */
            if (dayOfWeek === 0 || dayOfWeek === 6) {
              vD.shift = 12
            }
            console.log("VD", vD)
            const alreadyExists = inputDates.value.some(item => new Date(item.date).getTime() === new Date(vD.date).getTime())
            if (!alreadyExists) {
              inputDates.value.push(vD)
            }
            _anz++
          }
//          inputDates.value.splice(0, inputDates.value.length);
          
//          inputDates.value.push(...inputDatesTrimmed);
          inputDates.value.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
          console.log("Inputdates", inputDates.value)
        }
      }
      catch(ex){
        console.error(ex);
      }
    });
    
    onBeforeRouteLeave((to, from, next) => {
      if(edited.value)
      {
        createDialog({ title: "Änderungen verwerfen?",
          text: `Möchtest du deine Änderungen wirklich verwerfen?`,
          buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
            .then((answer) => {
              if(answer) {
                next();
              }
            })
      }
      else{
        next();
      }
    });

    function formatDateToYYYYMMDD(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}${month}${day}`;
    }
    
    function addDate(date: Date, shift: number) {
      const appTimezoneDate = toAppTimezone(date);
      if(vacation.value.filter(d => {
        const dDate = new Date(d.date); // Ensure d.Date is a Date object
        const comparisonDate = new Date(appTimezoneDate); // Ensure date is a Date object

        return (
            dDate.getFullYear() === comparisonDate.getFullYear() &&
            dDate.getMonth() === comparisonDate.getMonth() &&
            dDate.getDate() === comparisonDate.getDate()
        );
      }).length > 0) {
        notifyWarning("An diesem Tag kann kein Wunsch abgegeben werden, da Urlaub eingetragen ist.", {
          timeout: 10000,
          timer: true,
          closeOnContentClick: true
        }).then(() => {});
        return;
      }
      
      
      if (shift === 4 && nightexpress.value.filter(d => {
        const dDate = new Date(d.Date); // Ensure d.Date is a Date object
        const comparisonDate = new Date(appTimezoneDate); // Ensure date is a Date object

        return (
            dDate.getFullYear() === comparisonDate.getFullYear() &&
            dDate.getMonth() === comparisonDate.getMonth() &&
            dDate.getDate() === comparisonDate.getDate()
        );
      }).length === 0) {
        notifyWarning("An diesem Tag kann kein Nachtexpress Wunsch abgegeben werden.", {
          timeout: 10000,
          timer: true,
          closeOnContentClick: true
        }).then(() => {});
        return;
      }
      
      const index = inputDates.value.findIndex(d => isSameDate(d.date, appTimezoneDate));
      const oldValue = inputDates.value[index];
      console.log("Add Date", date, shift, index, oldValue, wishPeriod.value.startDate, wishPeriod.value.endDate)
      if(index !== -1) {
          inputDates.value.splice(index, 1);
        if(oldValue.shift !== shift && normalizeDate(appTimezoneDate) >= normalizeDate(wishPeriod.value.startDate) && 
          normalizeDate(appTimezoneDate) <= normalizeDate(wishPeriod.value.endDate)) {
          if(shift == 1 && inputDates.value.filter(d => d.shift === 1).length >= 30)
          {
            notifyWarning("Zuviele Frühschichten").then(() => {})
            return;
          }

          if(shift == 3 && inputDates.value.filter(d => d.shift === 3).length >= maxSpaetdiensteInEightWeeks)
          {
            notifyWarning("Zuviele Spätschichten").then(() => {})
            return;
          }

          if(shift == 2 && inputDates.value.filter(d => d.shift === 2).length >= maxMitteldiensteInEightWeeks)
          {
            notifyWarning("Zuviele Mittelschichten").then(() => {})
            return;
          }

          if(shift == 10 && inputDates.value.filter(d => d.shift === 10).length >= (maxFreeDaysInEightWeeks - vacationFreeDays.value))
          {
            notifyWarning("Zuviele Freie Tage").then(() => {})
            return;
          }
          
          inputDates.value.push({id: formatDateToYYYYMMDD(appTimezoneDate), date: appTimezoneDate, shift: shift});
          edited.value = true;
        }
      }
      else if(normalizeDate(appTimezoneDate) >= normalizeDate(wishPeriod.value.startDate) && 
        normalizeDate(appTimezoneDate) <= normalizeDate(wishPeriod.value.endDate)){
        if(shift == 1 && inputDates.value.filter(d => d.shift === 1).length >= maxFruehdiensteInEightWeeks)
        {
          notifyWarning("Zuviele Frühschichten").then(() => {})
          return;
        }

        if(shift == 3 && inputDates.value.filter(d => d.shift === 3).length >= maxSpaetdiensteInEightWeeks)
        {
          notifyWarning("Zuviele Spätschichten").then(() => {})
          return;
        }

        if(shift == 2 && inputDates.value.filter(d => d.shift === 2).length >= maxMitteldiensteInEightWeeks)
        {
          notifyWarning("Zuviele Mittelschichten").then(() => {})
          return;
        }

        if(shift == 10 && inputDates.value.filter(d => d.shift === 10).length >= (maxFreeDaysInEightWeeks - vacationFreeDays.value))
        {
          notifyWarning("Zuviele Freie Tage").then(() => {})
          return;
        }
        
        inputDates.value.push({id: formatDateToYYYYMMDD(appTimezoneDate), date: appTimezoneDate, shift: shift});
        edited.value = true;
      }
    }

    const goToOverview = async () => {
      if(localRulebreaks.value.length > 0)
      {
        await createDialog({
          title: "Regelverletzungen",
          text: `Es wurden Regelverletzungen festgestellt. Bitte diese korrigieren.`,
          buttons: [{title: "Ok", key: true}]
        });
        
        return;
      }
      
      
      createDialog({ title: "Daten abschicken",
        text: `Möchtest du deine Wünsche speichern und abschicken?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
          .then(async (answer) => {
            if(answer) {
              await save(true);
              
              if(employ.value)
              {
                await addDoc(collection(db, "mail"), {
                  to: employ.value.email,
                  message: {
                    subject: "Dein Wunschdienstplan wurde eingereicht!",
                    html:      "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                        `  <span>Dein Wunschdienstplan für die Wunschperiode <span style=\"color: #BE0081;\">${formatDateDE(wishPeriod.value.startDate)}</span> - <span style=\"color: #BE0081;\">${formatDateDE(wishPeriod.value.endDate)}</span> wurde eingereicht!</span>\n` +
                        "</div>\n" +
                        "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                        `  <span>Bis zur Deadline <span style=\"color: #BE0081;\">${formatDateDE(wishPeriod.value.deadline)}</span> kannst du den WDP noch anpassen!</span>\n` +
                        "</div>\n" +
                        "\n" +
                        "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                        "  <span>Es wird nun geprüft, in wie weit deine Wünsche <span style=\"color: #BE0081;\">berücksichtigt</span> werden können.</span>\n" +
                        "</div>\n" +
                        "\n" +
                        "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                        "  <span>Beachte, dass dieser Plan <span style=\"color: #BE0081;\">noch nicht bestätigt</span> ist!</span>\n" +
                        "</div>\n" +
                        "\n" +
                        "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                        "  <span>In der Zwischenzeit kannst du deine eingegebenen Wunschzeiten in der App oder deinen E-Mails <span style=\"color: #BE0081;\">einsehen.</span></span>\n" +
                        "</div>\n" +
                        "\n" +
                        "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                        "  <span>Sobald dein Dienstplan bearbeitet wurde, bekommst du eine <span style=\"color: #BE0081;\">Benachrichtigung.</span></span>\n" +
                        "</div>"
                  },
                });
              }
              
              await router.push(`/wunschdienst/overview/${wishPeriod.value.id.toString()}`)
            }
          })
    };
    
    const goBack = () => {
      if(edited.value)
      {
        createDialog({ title: "Änderungen verwerfen?",
          text: `Möchtest du deine Änderungen wirklich verwerfen?`,
          buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]})
            .then((answer) => {
              if(answer) {
                edited.value = false;
                router.push("/wuensche");
              }
            })
      }
      else{
        router.push("/wuensche");
      }
    }

    async function applyTemplate(template) {
      const fullTemplate = await GetTemplateData(template.id);
      
      var translatedArray = translateShifts(fullTemplate.dates);
      
      inputDates.value.splice(0, inputDates.value.length);
      translatedArray.forEach(date => {
          inputDates.value.push({id: uuidv4(), date: new Date(date.date), shift: date.shift});
      });
    }
    
    function translateShifts(shiftsArray) {
      // Define the original start date (1st January 2024)
      const originalStartDate = new Date("2024-01-01");

      // Convert the new start date to a Date object
      const newStart = new Date(wishPeriod.value.startDate);

      // Map over the shiftsArray to translate dates
      const translatedShifts = shiftsArray.map(shift => {
        // Calculate the difference in days between the shift date and originalStartDate
        const shiftDate = new Date(shift.date);
        const diffInDays = ((shiftDate - originalStartDate) / (1000 * 60 * 60 * 24)) + 2; // convert milliseconds to days

        // Translate the shift date by adding the difference to the new start date
        const newShiftDate = new Date(newStart);
        newShiftDate.setDate(newShiftDate.getDate() + diffInDays);

        // Return the translated shift
        return {
          shift: shift.shift,
          date: newShiftDate.toISOString().split('T')[0] // Format to YYYY-MM-DD
        };
      });

      return translatedShifts;
    }
    
    const wishessave = async () => {
      if(localRulebreaks.value.length > 0)
      {
        await createDialog({
          title: "Regelverletzungen",
          text: `Es wurden Regelverletzungen festgestellt. Bitte diese korrigieren.`,
          buttons: [{title: "Ok", key: true}]
        });
        
        return;
      }
      
      
      createDialog({ title: "Daten abschicken",
        text: `Möchtest du deine Wünsche speichern und abschicken?`,
        buttons: [{ title: "Ja", key: true }, { title: "Nein", key: false }]
      })
      .then(async (answer) => {
        if(answer) {
          await save(true);
          if (hostname.toLocaleLowerCase() === "wunschdienstplan.apps.new.de") {          
            if(employ.value)
            {
              await addDoc(collection(db, "mail"), {
                to: employ.value.email,
                message: {
                  subject: "Dein Wunschdienstplan wurde eingereicht!",
                  html:      "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                      `  <span>Dein Wunschdienstplan für die Wunschperiode <span style=\"color: #BE0081;\">${wishPeriod.value.startDate.toLocaleDateString("de-DE")}</span> - <span style=\"color: #BE0081;\">${wishPeriod.value.endDate.toLocaleDateString("de-DE")}</span> wurde eingereicht!</span>\n` +
                      "</div>\n" +
                      "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                      `  <span>Bis zur Deadline <span style=\"color: #BE0081;\">${wishPeriod.value.deadline.toLocaleDateString("de-DE")}</span> kannst du den WDP noch anpassen!</span>\n` +
                      "</div>\n" +
                      "\n" +
                      "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                      "  <span>Es wird nun geprüft, in wie weit deine Wünsche <span style=\"color: #BE0081;\">berücksichtigt</span> werden können.</span>\n" +
                      "</div>\n" +
                      "\n" +
                      "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                      "  <span>Beachte, dass dieser Plan <span style=\"color: #BE0081;\">noch nicht bestätigt</span> ist!</span>\n" +
                      "</div>\n" +
                      "\n" +
                      "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                      "  <span>In der Zwischenzeit kannst du deine eingegebenen Wunschzeiten in der App oder deinen E-Mails <span style=\"color: #BE0081;\">einsehen.</span></span>\n" +
                      "</div>\n" +
                      "\n" +
                      "<div style=\"font-family: Arial, sans-serif; line-height: 1.5; margin-bottom: 16px;\">\n" +
                      "  <span>Sobald dein Dienstplan bearbeitet wurde, bekommst du eine <span style=\"color: #BE0081;\">Benachrichtigung.</span></span>\n" +
                      "</div>"
                },
              });
            }
          }          
          await router.push(`/wunschdienst/overview/${wishPeriod.value.id.toString()}`)
        }
      })
/*      try {
        await save(false)
      }
      catch(e){
        overview.value = false
        console.error(e);
        notifyWarning("Daten konnten nicht gespeichert werden").then(() => {})
      }
      finally {
        overview.value = true
      }*/
    };

    const save = async (setFinishedTag:boolean) => {
      try {
        isSaving.value = true;
        let id:string;
        if (localWishData.value && localWishData.value.id) {
          id = localWishData.value.id;
        } else {
          id = wishPeriod.value.id + employ.value?.emplno.toString();
        }
        
          await InsertWishData({
            id: id,
            employNr: employ.value?.emplno,
            wishPeriodId: wishPeriod.value.id.toString(),
            userId: userId,
            bemerkung: localDescription.value}
              ,setFinishedTag);
        
        
          await InsertWishDataDates(id, wishPeriod.value.id, userData?.EmployData?.emplno, inputDates.value);
        }
      catch(e){
        console.error(e);
        notifyWarning("Daten konnten nicht gespeichert werden").then(() => {})
      }
      finally {
        edited.value = false;
        notifySuccess("Daten erfolgreich gespeichert").then(() => {})
        setTimeout(() => {
          isSaving.value = false;
        }, 2000);
        
      }
    };
    
    const dayClick = (day: CalendarDay) => {
      if(overview.value)
        return;
//      console.log("dayClick", day, selectedShift.value); 
      switch (selectedShift.value) {
        case 'frueh':
          addDate(day.date, 1);
          break;
        case 'spaet':
          addDate(day.date, 3);
          break;
        case 'mittel':
          addDate(day.date, 2);
          break;
        case 'geteilt':
          addDate(day.date, 5);
          break;
        case 'ne':
          addDate(day.date, 4);
          break;
        case 'frei':
          addDate(day.date, 10);
          break;
      }
    };
    
    const minDate = computed(() => {
      if (!wishPeriod.value?.startDate) return null;
      
      const minDateValue = new Date(wishPeriod.value.startDate);
      minDateValue.setDate(minDateValue.getDate() - 14);
      return minDateValue;
    });

    return { isLoading, localDescription, shiftLeftStrings, goToOverview, vacationFreeDays, isSaving, 
      freeDayTooltip, settings, goBack, shiftStrings, localRulebreaks, calendar,overview, templates,
      applyTemplate, selectedShift, save, wishessave, dateTimeString, wishPeriod, dayClick, attributes, 
      columns, expanded, minDate, canSave, dutyRulesText, wishInfoTitle, wishInfoTopText, wishSchemaTitle, wishSchemaSubtitle};
}
});
</script>

<style scoped>
:deep(.v-btn--size-small)
{
  font-size: 0.7rem;
  padding: 0px 10px;

}

:deep( >>>.vc-day.is-not-in-month *[data-v-005dafc8]) {
  color: red;
  opacity: 1 !important;
  pointer-events: inherit;
}

:deep(.vc-pane){
  margin-left: 40px;
  margin-right: 40px;
}

:deep(.vc-week){
  margin-bottom: 5px;
}
.my-calendar :deep(.vc-weekday-1, .vc-weekday-7) {
  color: #6366f1;
}

.shift-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.shift-item {
  flex: 1 0 30%; /* 30% to ensure 3 items per row with some space between */
  text-align: center;
  margin: 5px;
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #ccc; /* Optional: for visual separation */
}

.calendarBox{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  flex-direction: column;
   /* or specify a color, e.g., color: black; */
}

.buttonBox{
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  flex-direction: column;
}

.dateBox{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100px;
  background: #B40055;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}

.year{
  font-size: 18px;
  color: white;
  text-align: center;
  margin-bottom: 3px;
}

.date{
  font-size: 24px;
  color: white;
  text-align: center;
}

</style>
  